if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');
      }

      get variantIdSelect() {
        return this.querySelector('[name="id"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');

        this.variantData = this.getVariantData();
        this.select = this.querySelector('select');

        this.init();
        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.variantIdSelect.value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
          
          // Update variant text on mobile
          this.updateVariantText();
          
          // Update select prices with current plan
          this.updateSelectPrices();
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          document.body.classList.add('sticky-atc-bar-visible');
          return;
        }
        this.productId = this.dataset.productId;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isVisible = !entry.isIntersecting;
              this.container.classList.toggle('sticky-atc-bar--show', isVisible);
              document.body.classList.toggle('sticky-atc-bar-visible', isVisible);
              
              // Update plan display when sticky bar becomes visible
              if (isVisible) {
                setTimeout(() => this.updatePlanDisplay(), 100);
              }
            });
          },
          { threshold: 1, rootMargin }
        );
        this.observer.observe(this.productFormActions);
        this.syncWithMainProductForm();
        
        // Initial plan display and price update after a short delay to ensure plan picker is loaded
        setTimeout(() => {
          this.updatePlanDisplay();
          this.updateSelectPrices();
        }, 500);
      }

      checkDevice() {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.sticky-atc-bar__form');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = `<s>${FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat)}</s>`)
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }
          
          // Update plan display and select prices when variant changes
          this.updatePlanDisplay();
          this.updateSelectPrices();
        });

        // Listen to Skio plan picker changes from main product form
        this.updatePlanDisplay();
        this.updateSelectPrices();
        document.addEventListener('skio::update-selling-plan', (event) => {
          // Only update if this is from the main product form's plan picker
          const mainPlanPicker = this.mainProductInfo?.querySelector('skio-plan-picker');
          if (mainPlanPicker && event.target === mainPlanPicker) {
            this.updatePlanDisplay(event.detail.sellingPlan, event.detail.variant);
            this.updateSelectPrices(event.detail.sellingPlan, event.detail.variant);
          }
        });
      }

      updatePlanDisplay(sellingPlan = null, variant = null) {
        // Update both desktop and mobile plan displays
        const planInfoDesktop = this.querySelector('.sticky-atc-bar__plan-info:not(.sticky-atc-bar__plan-info-mobile)');
        const planInfoMobile = this.querySelector('.sticky-atc-bar__plan-info-mobile');
        
        // If no selling plan provided, try to get it from the main product form's plan picker
        if (!sellingPlan) {
          const mainPlanPicker = this.mainProductInfo?.querySelector('skio-plan-picker');
          if (mainPlanPicker) {
            sellingPlan = mainPlanPicker.selectedSellingPlan;
            variant = variant || mainPlanPicker.selectedVariant;
          }
        }

        const updatePlanElements = (planInfo) => {
          if (!planInfo) return;
          
          const planNameEl = planInfo.querySelector('[data-plan-name], [data-plan-name-mobile]');
          const planFrequencyEl = planInfo.querySelector('[data-plan-frequency], [data-plan-frequency-mobile]');
          
          if (!planNameEl || !planFrequencyEl) return;
          
          if (sellingPlan && sellingPlan.name) {
            // Get selling plan name (frequency) - e.g., "Every 4 weeks", "Every 1 month"
            const frequency = sellingPlan.name || '';
            
            // Format as "Delivered every [frequency]"
            planNameEl.textContent = 'Delivered every';
            planFrequencyEl.textContent = frequency.toLowerCase().replace('every ', '');
            planInfo.style.display = 'flex';
          } else {
            // Show "Delivered one-time" when no plan selected (one-time purchase)
            planNameEl.textContent = 'Delivered';
            planFrequencyEl.textContent = 'one-time';
            planInfo.style.display = 'flex';
          }
        };

        // Update desktop display
        if (planInfoDesktop) {
          updatePlanElements(planInfoDesktop);
        }
        
        // Update mobile display
        if (planInfoMobile) {
          updatePlanElements(planInfoMobile);
        }
      }

      updateSelectPrices(sellingPlan = null, variant = null) {
        const select = this.querySelector('.sticky-atc-bar__variant-select');
        if (!select || !this.variantData) return;

        // If no selling plan provided, try to get it from the main product form's plan picker
        if (!sellingPlan) {
          const mainPlanPicker = this.mainProductInfo?.querySelector('skio-plan-picker');
          if (mainPlanPicker) {
            sellingPlan = mainPlanPicker.selectedSellingPlan;
            variant = variant || mainPlanPicker.selectedVariant;
          }
        }

        const selectedVariantId = select.value;
        const currentVariant = variant || this.variantData.find((v) => v.id === Number(selectedVariantId));
        if (!currentVariant) return;

        // Update all options with their respective prices based on selling plan
        Array.from(select.options).forEach((option) => {
          const optionVariant = this.variantData.find((v) => v.id === Number(option.value));
          if (!optionVariant) return;

          // Calculate price based on selling plan for this variant
          let displayPrice = optionVariant.price;
          if (sellingPlan && sellingPlan.price_adjustments && sellingPlan.price_adjustments.length > 0) {
            // Calculate discount amount from price adjustments
            const priceAdjustment = sellingPlan.price_adjustments[0];
            let discountAmount = 0;

            if (priceAdjustment.value_type === 'percentage') {
              discountAmount = Math.round(optionVariant.price * (priceAdjustment.value / 100));
            } else if (priceAdjustment.value_type === 'fixed_amount') {
              discountAmount = priceAdjustment.value;
            }

            displayPrice = optionVariant.price - discountAmount;
          }

          // Format price using FoxTheme currency formatter
          const moneyFormat = FoxTheme.settings.moneyFormat || '${{amount}}';
          const formattedPrice = FoxTheme.Currency.formatMoney(displayPrice, moneyFormat);

          // Extract variant title (preserve original if available, otherwise parse from current text)
          const variantTitle = optionVariant.title || option.text.split(' - ')[0];
          option.textContent = `${variantTitle} - ${formattedPrice}`;
        });
      }
    }
  );
}
